/* Podobne Nuty: slider oryginałów (snippets/podobne-nuty.liquid) */
(function () {
  if (window.__podobneNuty) return;
  window.__podobneNuty = true;

  function init(root) {
    if (root.dataset.pnReady) return;
    root.dataset.pnReady = '1';
    var track = root.querySelector('[data-pn-track]');
    if (!track) return;
    var count = track.children.length;
    var dots = root.querySelectorAll('[data-pn-dot]');
    var prev = root.querySelector('[data-pn-prev]');
    var next = root.querySelector('[data-pn-next]');

    function index() { return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
    function go(i) {
      i = Math.max(0, Math.min(count - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function update() {
      var i = index();
      for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-active', k === i);
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= count - 1;
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pn-prev],[data-pn-next],[data-pn-dot]');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      if (b.hasAttribute('data-pn-prev')) go(index() - 1);
      else if (b.hasAttribute('data-pn-next')) go(index() + 1);
      else go(parseInt(b.getAttribute('data-pn-dot'), 10));
    });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    /* Gest na sliderze nie przesuwa nadrzędnej karuzeli produktów */
    ['pointerdown', 'pointermove', 'touchstart', 'touchmove'].forEach(function (ev) {
      track.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true });
    });
    update();
  }

  function initAll() { document.querySelectorAll('[data-pn]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
